import React, { useState, useEffect, useContext } from 'react';
import '../../css/home/home.css'; // Asegúrate de crear este archivo CSS también
import { AuthContext } from '../../context/AuthContext';
import { formatAmount, FormatMontoPSE } from '../../utils/Utils';
import { IoIosArrowRoundDown } from "react-icons/io";
import axios from 'axios';
import { motion } from 'framer-motion';
import ModalAlert from '../../components/modal/ModalAlert'
import moment from 'moment';

import CustomTable from '../../components/table/CustomTable';
import InputAmount from '../../components/inputs/InputAmount';
import ButtonBack from '../../components/button/ButtonBack';
import ButtonWhite from '../../components/button/ButtonWhite';
import ModalQuote from '../../components/modal/modalCotizar/ModalQuote';
import ConfirmPurchase from '../../components/layouts/cotizar/ConfirmPurchase';
import Create2FA from '../../components/layouts/cotizar/Create2FA';
import ConfirmOTP from '../../components/layouts/ConfirmOTP';
import { CalendarToday, AccessTime } from "@mui/icons-material";

import { FaArrowRightLong } from "react-icons/fa6";

import { FaRegClock, FaRegCalendarAlt } from 'react-icons/fa';
import { BsArrowDownCircle } from 'react-icons/bs';

import USD from '../../assets/currency/usd.png';
import COP from '../../assets/currency/copu.png';
import ModalSend from '../../components/modal/modalTransaction/modalSend'

// Nuevos imports para multi retiros
import SelectSendBank from '../../components/layouts/home/send/selectSendBank';
import MultiSendBank from '../../components/layouts/home/send/multiSendBank';
import SelectSend from '../../components/layouts/home/send/selectSend';
import CreateAccountBank from '../../components/layouts/home/send/createAccountBank';

import { ReactComponent as Check } from '../../assets/IconsColurs/IconsGeneral/checkFilled.svg';
import { UtilContext } from '../../context/UtilContext';
import { IoIosClose } from 'react-icons/io';

const Quote = () => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [TotalRow, setTotalRow] = useState("");
    const [Page, setPage] = useState("");

    const [activeSend, setActiveSend] = useState(false)

    // Variables para multi retiros
    const [activeMultiRetiros, setActiveMultiRetiros] = useState(false);
    const [retiroStep, setRetiroStep] = useState("select"); // "select", "fast", "multi"
    const [bankAccounts, setBankAccounts] = useState([]);
    const [loadingBankAccount, setLoadingBankAccount] = useState(false);
    const [errorBankAccount, setErrorBankAccount] = useState('');
    const [bankUserList, setBankUserList] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null);

    // Variables para agregar cuenta bancaria
    const [nombres, setNombres] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState(0);
    const [documento, setDocumento] = useState('');
    const [bancoSeleccionado, setBancoSeleccionado] = useState(null);
    const [numeroCuenta, setNumeroCuenta] = useState('');
    const [tipoCuenta, setTipoCuenta] = useState(null);
    const [errorADDBank, setErrorADDBank] = useState('');
    const [previousStep, setPreviousStep] = useState(null);

    // Lista de bancos para COP
    const [listaBancos] = useState([
        { name: "Agrario", code: 8 },
        { name: "AV Villas", code: 12 },
        { name: "Bancolombia", code: 0 },
        { name: "Bancoomeva", code: 15 },
        { name: "BBVA", code: 3 },
        { name: "BCSC", code: 9 },
        { name: "Banco Bogota", code: 1 },
        { name: "Caja Social", code: 34 },
        { name: "Citybank", code: 11 },
        { name: "Colpatria", code: 5 },
        { name: "Coltefinanciera", code: 24 },
        { name: "Confiar", code: 31 },
        { name: "Cooperativa Financiera de Antioquia", code: 29 },
        { name: "Cooperativo Coopcentral", code: 26 },
        { name: "Cootrafa Cooperativa Financiera", code: 32 },
        { name: "Davivienda", code: 2 },
        { name: "Daviplata", code: 19 },
        { name: "Falabella", code: 17 },
        { name: "Finandina", code: 20 },
        { name: "Financiera Juriscoop SA", code: 30 },
        { name: "GNB Sudameris", code: 33 },
        { name: "Helm", code: 7 },
        { name: "Itau", code: 21 },
        { name: "Itau Corbanca", code: 22 },
        { name: "Lulo Bank", code: 23 },
        { name: "Nequi", code: 18 },
        { name: "NU", code: 35 },
        { name: "Occidente", code: 4 },
        { name: "Popular", code: 6 },
        { name: "Pichincha", code: 14 },
        { name: "Procredit", code: 13 },
        { name: "RappiPay", code: 28 },
        { name: "Santander", code: 16 },
        { name: "UALA", code: 25 },
    ]);

    // Mapeo de códigos de banco a nombres
    const bankCodeToName = {
        0: "Bancolombia",
        1: "Banco de Bogotá",
        2: "Banco Popular",
        3: "BBVA",
        4: "Colpatria",
        5: "Davivienda",
        6: "Banco AV Villas",
        7: "Banco Caja Social",
        8: "Banco Agrario",
        9: "Banco BCSC",
        10: "Banco Colmena",
        11: "Banco Coomeva",
        12: "Banco AV Villas",
        13: "Banco Falabella",
        14: "Banco Pichincha",
        15: "Bancoomeva",
        16: "Banco Santander",
        17: "Banco de Occidente",
        18: "Nequi",
        19: "Daviplata",
        20: "Movii"
    };

    const { getAuthenticatedHeaders, DetailUser, fetchUserDetails } = useContext(AuthContext);
    const { longitude, latitude, IP } = useContext(UtilContext);

    const [balanceWalletCop, setBalanceWalletCop] = useState('');
    const [errorTime, setErrorTime] = useState('');
    const [MaxAmount, setMaxAmount] = useState('');
    const [MaxAmountCount, setMaxAmountCount] = useState('');
    const [LoadingTableRetiros, setLoadingTableRetiros] = useState(false);



    const [Modal2FA, setModal2FA] = useState(false);
    const [DataQr, setDataQr] = useState('');
    const [otp, setOtp] = useState(["", "", "", "", "", "",]);
    const [otpValid, setOtpValid] = useState(["", "", "", "", "", "",]);

    const [valueOTP, setValueOTP] = useState(["", "", "", "", "", "",]);
    const [isOTP, setisOTP] = useState(false);
    const [errorOTP, setErrorOTP] = useState("");
    const [ListData, setListData] = useState([]);
    const [Max, setMax] = useState("");
    const [MaxValue, setMaxValue] = useState("");
    const [modalOTP, setModalOTP] = useState(false);
    const [TotalRowRetiros, setTotalRowRetiros] = useState("");
    const [ListDataRetiros, setListDataRetiros] = useState([]);
    const [Percent, setPercent] = useState("");




    const [loadingTable, setLoadingTable] = useState(false);



    const [OTPCreate, setOTPCreate] = useState(false);

    const [loadingOTP, setLoadingOTP] = useState(false);




    const [loadingCotizar, setLoadingCotizar] = useState(false);

    const [balanceWalletUsd, setBalanceWalletUsd] = useState('');
    const [balanceWalletCOP, setBalanceWalletCOP] = useState('');

    const [error, setError] = useState('');
    const [ModalActive, setModalActive] = useState(false);
    const [counter, setCounter] = useState(60);
    const [controller, setController] = useState(null);
    const [loadingAddressQr, setLoadingAddressQr] = useState(false);
    const [loading, setLoading] = useState(false);
    const [id, setID] = useState(null);
    const [LoadingData, setLoadingData] = useState(false);
    const [addressQrUSDT, setAddressQrUSDT] = useState(false);
    const [addressQrUSDC, setAddressQrUSDC] = useState(false);
    const [activeConfimPurchase, setActiveConfimPurchase] = useState(false);
    const [dailyLimit, setDailyLimit] = useState("50000");
    const [budgetLimit, setBudgetLimit] = useState("50000");
    const [activeQoute, setActiveQoute] = useState(false);
    const [loadingAmount, setLoadingAmount] = useState(false);
    const [amountUSD, setAmountUSD] = useState('');
    const [amountCOP, setAmountCOP] = useState('');
    const [finalAmountCOP, setfinalAmountCOP] = useState('');
    const [tasaForex, setTasaForex] = useState(0);
    const [purchaseCommission, setPurchaseCommission] = useState(null);
    const [purchaseCommissionIVA, setPurchaseCommissionIVA] = useState(null);
    const [totalPurchase, setTotalPurchase] = useState(null);
    const [confirmPurchase, setConfirmPurchase] = useState(false);
    const [contador, setContador] = useState(30);
    const [time, setTime] = useState(0);
    const [activeCotizar, setActiveCotizar] = useState(true);
    const [activeEjecutar, setActiveEjecutar] = useState(true);
    const [activeCompraFinal, setActiveCompraFinal] = useState(false);
    const [timerActive, setTimerActive] = useState(false); // Estado para controlar el temporizador
    const [newPerPage, setPerPage] = useState(10)
    const [LoadingTableSkeleton, setLoadingTableSkeleton] = useState(true)

    const [loadingDispersion, setLoadingDispersion] = useState(false);
    const [modalDispersionSuccess, setModalDispersionSuccess] = useState(false);
    const [modalDispersionError, setModalDispersionError] = useState(false);

    // Temporizador
    useEffect(() => {
        let interval;
        if (timerActive && counter > 0) {
            interval = setInterval(() => {
                setCounter((prevCounter) => prevCounter - 1);
            }, 1000);
        } else if (counter === 0) {
            setTimerActive(false); // Detener el temporizador cuando llegue a cero
            setCounter(0); // Reiniciar el contador
        }

        return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
    }, [timerActive, counter]);

    // Función para activar el temporizador
    const startTimer = () => {
        setTimerActive(true);
        setCounter(60); // Reiniciar el contador a 30 segundos
    };

    // Función para detener el temporizador
    const stopTimer = () => {
        setTimerActive(false);
        setCounter(60); // Reiniciar el contador
    };



    const PriceDolar = async () => {
        if (amountUSD !== "") {
            setLoadingCotizar(true)
        }
        setLoadingData(true);

        await axios
            .post(`/api/exchange_rate`, {
                headers: await getAuthenticatedHeaders(),
                from: "USD",
                to: "COP",
                amount: amountUSD === "" ? "1" : amountUSD,
                action: "QUOTE"
            })
            .then((response) => {
                if (response.data.status === 200) {
                    if (amountUSD !== "") {
                        setTime(30);
                        setActiveCotizar(true)
                        setActiveEjecutar(false);
                        startTimer(); // Activar el temporizador
                    }
                    setMaxAmountCount(response.data.data.quote_remaining_value)
                    setMaxAmount(response.data.data.maximum_value)
                    setPercent(response.data.data.fee_exchange_rate)
                    setTasaForex(parseFloat(response.data.data.trm_rate));
                    setAmountCOP(response.data.data.target_amount);
                    setError("");
                } else if (response.data.status === 400) {

                    if (
                        response.data.data.code_transaction === "BalanceInsufficient" && amountUSD !== ""
                    ) {
                        setError("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")

                    }

                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingCotizar(false)
        setLoadingData(false);
    };

    const translateBackendMessage = (message) => {
        const regex = /(\d{1,2}:\d{2} [APM]{2}) and (\d{1,2}:\d{2} [APM]{2})/;
        const match = message.match(regex);

        if (match) {
            const startTime = match[1];
            const endTime = match[2];

            return `Las cotizaciones están permitidas entre ${startTime} y ${endTime}.`;
        }

        return "";
    };

    const formatToTwoDecimals = (num) => {
        return new Intl.NumberFormat("es-CO", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };


    const columns = [


        {
            name: 'Monto a enviar',
            selector: (row) => `$ ${(row.usd_amount)} USD`,
            sortable: true,
        },
        {
            name: 'Monto a recibir',
            selector: (row) => (
                <div className="flex flex-row items-center">
                    <div className='rounded-full bg-[#2e2f35] w-6 h-6 justify-center flex items-center '>

                        <FaArrowRightLong className="rotate-90 w-full" />
                    </div>

                    <div className=' flex flex-col ml-2'>

                        <span className="text-white font-semibold">Recibiste</span>
                        <span className="text-gray-400 text-sm">$ {row.cop_amount} COP</span>
                    </div>
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Tasa de cotizacion',
            selector: (row) => `$ ${formatToTwoDecimals(row.amount_trm)} COP`,
            sortable: true,
        },
        {
            name: 'Estado',
            cell: (row) => (
                <div className={`text-xs px-3 py-1 rounded-full font-medium ${row.status === 'Aprobado' ? 'bg-[#BDFFFF] text-black' : row.status === "Rechazada" ? 'bg-[#e4847f] text-black' : 'bg-[#FAECDC] text-black'}`}>
                    {row.status}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Fecha y hora',
            cell: (row) => (
                <div className="flex items-center gap-2 text-gray-400">
                    <FaRegCalendarAlt size={14} />
                    {moment(row.date_created).format("DD/MM/YY")}
                    <FaRegClock size={14} />
                    {moment(row.date_created).format("hh:mm a")}
                </div>
            ),
            sortable: true,
        },

        {
            name: 'Entrega',
            selector: (row) => row.delivery_time == null && row.status == "Pendiente" ? "Pendiente" : row.delivery_time == null && row.status == "Rechazada" ? "Rechazado" : `${moment(row.delivery_time).format("DD/MM/YY - hh:mm a")}`,
            sortable: true,
        },
    ];

    const PreExchange = async () => {
        setLoading(true);
        await axios
            .post(`/api/quote`, {
                headers: await getAuthenticatedHeaders(),
                from: "USD",
                to: "COP",
                amount: amountUSD,
                action: "QUOTE"
            })
            .then((response) => {
                if (response.data.status === 201) {

                    setPurchaseCommission(response.data.data.data.fee_amount)
                    setPurchaseCommissionIVA(response.data.data.data.fee_iva_amount)
                    setTotalPurchase(response.data.data.data.source_amount)
                    setActiveConfimPurchase(true);
                    setID(response.data.data.data.id);
                } else if (response.data.status === 400) {

                    if (response?.data.data?.non_field_errors) {
                        const errorMessage = response.data.data.non_field_errors[0];

                        if (errorMessage.includes("Only can convert 50000.00 per day")) {
                            setError("El monto máximo diario de monetización es de $50.000 dólares.")
                        } else {
                            console.log(errorMessage); // Para otros posibles errores
                        }
                    }

                }
                if (response.data.data.code_transaction === "AvailableTime") {

                    setErrorTime(translateBackendMessage(response.data.data.message))
                }



            })
            .catch((error) => {
                console.error(error);
            });
        setLoading(false);
    };

    const ConfirmExchange = async () => {
        setLoadingOTP(true);
        await axios
            .post(`/api/swap`, {
                headers: await getAuthenticatedHeaders(),
                from: "USD",
                to: "COP",
                amount: amountUSD,
                code: otpValid.join(""),
                action: "QUOTE",
                quote_id: id,
                latitude: latitude,
                longitude: longitude,
                ip: IP
            })
            .then((response) => {
                if (response.data.status === 201) {

                    WalletBalanceHomeCOP()
                    ListQuote()
                    setOtpValid(["", "", "", "", "", "",])
                    setModalOTP(false)
                    setConfirmPurchase(true);
                    setErrorOTP("")
                    setTitle("Transaccion completada");
                    setDescription("");
                } else if (response.data.status === 400) {
                    if (response.data.data.message === "Insufficient balance") {
                        setErrorOTP("Balance insuficiente");
                    }
                    else if (response.data.data.message === "{'non_field_errors': [ErrorDetail(string='The quote has expired. You must request a new quote', code='invalid')]}") {
                        setErrorOTP("La cotización ha expirado. Solicita una nueva.");

                    } else {

                        setErrorOTP("Código inválido o expirado. Intenta de nuevo");

                    }

                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingOTP(false);
    };

    useEffect(() => {
        if (parseFloat(amountUSD) < 1000) {
            setError("El monto minimo son $1.000 USD");
        } else {
            setError("");
        }

        if (amountUSD) {
            setActiveCotizar(false);
        } else {
            setActiveEjecutar(true);
            setAmountCOP('');
            setActiveCotizar(true);
        }
    }, [amountUSD, tasaForex]);

    useEffect(() => {
        if (counter <= 0) {
            setActiveCotizar(false)
            setActiveEjecutar(true)
            // Detener el temporizador cuando llegue a cero
        }
    }, [counter]);

    useEffect(() => {
        WalletBalanceHomeCOP()
        PriceDolar()
    }, []);

    // Efecto para cerrar el modal de selección cuando se abre ModalSend
    useEffect(() => {
        if (activeSend) {
            setActiveMultiRetiros(false);
        } else if (retiroStep === "fast") {
            // Si se cierra el ModalSend y estábamos en el paso "fast", restaurar el modal de selección
            setActiveMultiRetiros(true);
            setRetiroStep("select");
        }
    }, [activeSend, retiroStep]);

    // Efecto para cargar la lista de bancos cuando se abre el modal de multi retiros
    useEffect(() => {
        console.log("useEffect ejecutándose:", { activeMultiRetiros, retiroStep });
        console.log("bankUserList antes de BankListUser:", bankUserList);
        if (activeMultiRetiros && retiroStep === "multi") {
            BankListUser();
        }
    }, [activeMultiRetiros, retiroStep]);

    const closeAllModals = () => {

        setAmountUSD('')
        setAmountCOP('')
        setErrorTime("")


    };
    const GetOTP = async () => {
        setLoadingOTP(true);
        await axios
            .post(`/api/otp`, {
                headers: await getAuthenticatedHeaders(),

            })
            .then((response) => {
                if (response.data.status === 200) {
                    setDataQr(response.data.data.uri);
                    setModal2FA(true)


                } else if (response.data.status === 400) {
                    console.log(response.data.data.message);
                    setError(response.data.data.message);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingOTP(false);
    };


    const handleChange = (value, index) => {
        const newOtp = [...otp];
        newOtp[index] = value.slice(-1); // Solo permite un carácter
        setOtp(newOtp);

        // Mueve el foco al siguiente input si hay un valor
        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }

        // Si todos los dígitos están llenos, puedes hacer algo (como enviar el OTP)
        if (newOtp.every((digit) => digit !== '')) {
            setValueOTP(newOtp)
            // Aquí puedes agregar la lógica para manejar el OTP completo
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
            if (otp[index] === '') {
                // Si el campo actual está vacío, retrocede al campo anterior
                if (index > 0) {
                    const newOtp = [...otp];
                    newOtp[index - 1] = ''; // Borra el dígito del campo anterior
                    setOtp(newOtp);
                    document.getElementById(`otp-input-${index - 1}`).focus(); // Mueve el foco al campo anterior
                }
            } else {
                // Si hay un valor en el campo actual, simplemente lo borra
                const newOtp = [...otp];
                newOtp[index] = ''; // Borra el dígito del campo actual
                setOtp(newOtp);
            }
        }
    };
    const handlePaste = (event) => {
        event.preventDefault(); // Evita el comportamiento predeterminado

        const pastedData = event.clipboardData.getData('Text').trim().slice(0, 6); // Extrae solo 6 caracteres
        if (!/^[0-9]+$/.test(pastedData)) return; // Verifica que solo sean números

        const newOtp = pastedData.split("");

        setOtp(newOtp);
        setValueOTP(newOtp);

        // Usa setTimeout para permitir que React actualice el estado antes de manipular los inputs
        setTimeout(() => {
            newOtp.forEach((digit, index) => {
                const inputElement = document.getElementById(`otp-input-${index}`);
                if (inputElement) {
                    inputElement.value = digit;
                }
            });

            // Mueve el foco al siguiente campo si hay espacio
            const lastIndex = newOtp.length < 6 ? newOtp.length : 5;
            document.getElementById(`otp-input-${lastIndex}`)?.focus();
        }, 0);
    };


    const MovementsList = async () => {
        console.log("hola");


    };


    const NewOTPRequest = async () => {

        setLoadingOTP(true);
        await axios
            .post(`/api/confirm_otp`, {
                headers: await getAuthenticatedHeaders(),
                code: valueOTP.join("")
            })
            .then((response) => {
                if (response.data.status === 200) {

                    setOTPCreate(true)

                } else if (response.data.status === 400) {
                    setErrorOTP(response.data.data.error);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingOTP(false);
    };


    const ListQuote = async () => {

        setLoadingTable(true);
        await axios
            .post(`/api/quote_list`, {
                headers: await getAuthenticatedHeaders(),
                pageQuote: 1,
                pageRetiros: 1,
                perPage: 5

            })
            .then((response) => {
                if (response.data.status === 200) {
                    console.log("data", response.data?.data?.data.quotes);

                    setTotalRow(response.data?.data?.data.quotes.count)
                    setListData(response.data?.data?.data.quotes.results)
                    setTotalRowRetiros(response.data?.data?.data.withdraws.count)
                    setListDataRetiros(response.data?.data?.data.withdraws.results)
                } else if (response.data.status === 400) {
                    setErrorOTP(response.data.data.error);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingTableSkeleton(false)
        setLoadingTable(false);
    };
    const ListQuotePage = async (page) => {

        setLoadingTable(true);
        await axios
            .post(`/api/quote_list`, {
                headers: await getAuthenticatedHeaders(),
                pageRetiros: null,
                perPage: 5,
                pageQuote: page

            })
            .then((response) => {
                if (response.data.status === 200) {

                    setTotalRow(response.data?.data?.data.quotes.count)
                    setListData(response.data?.data?.data.quotes.results)
                    setTotalRowRetiros(response.data?.data.data?.withdraws.count)
                    setListDataRetiros(response.data?.data.data?.withdraws.results)

                } else if (response.data.status === 400) {
                    setErrorOTP(response.data.data.error);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingTable(false);
    };
    const ListQuotePageRetiros = async (page) => {

        setLoadingTableRetiros(true);
        await axios
            .post(`/api/quote_list`, {
                headers: await getAuthenticatedHeaders(),
                pageQuote: null,
                perPage: 5,
                pageRetiros: page

            })
            .then((response) => {
                if (response.data.status === 200) {

                    setTotalRow(response.data?.data?.data.quotes.count)
                    setListData(response.data?.data?.data.quotes.results)
                    setTotalRowRetiros(response.data?.data.data?.withdraws.count)
                    setListDataRetiros(response.data?.data.data?.withdraws.results)

                } else if (response.data.status === 400) {
                    setErrorOTP(response.data.data.error);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        setLoadingTableRetiros(false);
    };



    useEffect(() => {

        setErrorOTP("")
        if (otp.join("").length === 6) {
            setErrorOTP("")
            NewOTPRequest()
        }
    }, [otp])
    useEffect(() => {

        setErrorOTP("")
        if (otpValid.join("").length === 6) {
            setErrorOTP("")
            ConfirmExchange()
        }
    }, [otpValid])

    const onCloseOTP = () => {
        setValueOTP(["", "", "", "", "", "",])
        setOtp(["", "", "", "", "", "",])
        setErrorOTP("")
        setOTPCreate(false)
        fetchUserDetails()
        setModal2FA(false)
        setisOTP(false)
    }
    const backOTP = () => {
        setValueOTP(["", "", "", "", "", "",])
        setOtp(["", "", "", "", "", "",])
        setErrorOTP("")
        setOTPCreate(false)
        fetchUserDetails()

        setisOTP(false)
    }


    useEffect(() => {
        ListQuote()
    }, [])
    const columnsRetiros = [
        {
            name: "Ref",
            selector: (row) => (
                <div /* onClick={() => handle(row.id)} */ className="cursor-pointer">

                    {row.id}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Nombre",
            selector: (row) => (row.username),
            sortable: true,
        },

        {
            name: "FEE",
            selector: (row) => `$ ${formatToTwoDecimals(`${row.cobru_fee}`)} COP`,
            sortable: true,
        },
        {
            name: "IVA",
            selector: (row) => `$ ${formatToTwoDecimals(`${row.cobru_fee_iva}`)} COP`,
            sortable: true,
        },
        {
            name: "GMF",
            selector: (row) => `$ ${formatToTwoDecimals(`${row.gmf}`)} COP`,
            sortable: true,
        },

        {
            name: "Monto",
            selector: (row) => `$ ${formatToTwoDecimals(`${row.payed_amount}`)} COP`,
            sortable: true,
        },

        {
            name: "Fecha y hora",
            cell: (row) => (



                <div className="flex items-center gap-2 text-gray-400">
                    <FaRegCalendarAlt size={14} />
                    {moment(row.date_created).format("DD/MM/YY")}
                    <FaRegClock size={14} />
                    {moment(row.date_created).format("hh:mm a")}
                </div>
            ),
            sortable: true,
        },
        {
            name: "Estado",
            cell: (row) => (
                <div className="flex flex-row">
                    <div className={`text-xs px-3 py-1 rounded-full font-medium ${row.state === 3 ? 'bg-[#BDFFFF] text-black' : row.state === 4 ? 'bg-[#e4847f] text-black' : 'bg-[#FAECDC] text-black'}`}>
                        {row.state === 3 ? "Aprobado" : row.state === 4 ? "Rechazado" : "Pendiente"}
                    </div>


                </div>
            ),
            sortable: true,
        },


    ];

    const handlePageChange = page => {
        ListQuotePage(page);
    };
    const handlePageChangeRetiros = page => {
        ListQuotePageRetiros(page);
    };

    const WalletBalanceHomeCOP = async () => {


        setLoadingAmount(true);
        try {
            const response = await axios.post(`/api/wallet_quote_cop`, {
                headers: await getAuthenticatedHeaders(),
            });

            const balances = response.data.data;
            console.log("copBalance", balances);
            const copBalance = balances.find(item => item.currency.code === "COP")?.balance || "0.00";
            const usdBalance = balances.find(item => item.currency.code === "USD")?.balance || "0.00";

            setBalanceWalletUsd(usdBalance);
            setBalanceWalletCOP(copBalance);
        } catch (error) {
            setLoadingAmount(false);
            console.error("Error fetching wallet balance:", error);
        }
        setLoadingAmount(false);
    };

    // Funciones para multi retiros
    const handleFastSendRetiro = () => {
        setRetiroStep("fast");
        setActiveSend(true);
    };

    const handleMultiSendRetiro = () => {
        setRetiroStep("multi");
        setActiveMultiRetiros(true);
    };

    const validateBankAccount = async () => {
        if (!selectedBank) {
            setErrorBankAccount("Por favor seleccione un banco");
            return;
        }

        setLoadingBankAccount(true);
        setErrorBankAccount('');

        try {
            const newBankAccount = {
                id: Date.now(),
                pk: selectedBank.pk,
                thirdpartybank_id: selectedBank.pk,
                account_number: selectedBank.account_number,
                bank_name: selectedBank.bank_name,
                account_holder_name: selectedBank.account_holder_name,
                account_type: selectedBank.account_type,
                amount: ""
            };

            setBankAccounts([...bankAccounts, newBankAccount]);
            setSelectedBank(null);
        } catch (error) {
            setErrorBankAccount("Error al agregar el banco");
        } finally {
            setLoadingBankAccount(false);
        }
    };

    const BankListUser = async () => {
        console.log("Ejecutando BankListUser");
        await axios
            .post(`/api/list_third_party_banks`, {
                headers: await getAuthenticatedHeaders(),
                country: "CO"
            })
            .then((response) => {
                console.log("Respuesta de la API:", response.data);
                if (response.data.status === 200) {
                    // Mapear los códigos de banco a nombres
                    const banksWithNames = response.data.data.results.map(bank => ({
                        ...bank,
                        bank_name: bankCodeToName[bank.bank_name] || `Banco ${bank.bank_name}`
                    }));
                    console.log("banksWithNames:", banksWithNames);
                    setBankUserList(banksWithNames);
                    console.log("bankUserList después de setBankUserList:", banksWithNames);
                } else if (response.data.status === 400) {
                    if (response.data?.data?.non_field_errors == "The available balance is less than the amount deposited") {
                        setErrorBankAccount("Saldo Insuficiente. Ingresa otro valor o recarga tu billetera y vuelve a intentarlo.")
                    }
                }
            })
            .catch((error) => {
                console.log("Error en BankListUser:", error);
                setLoadingBankAccount(false);
            });
        setLoadingBankAccount(false);
    };

    const closeMultiRetiros = () => {
        setActiveMultiRetiros(false);
        setRetiroStep("select");
        setBankAccounts([]);
        setErrorBankAccount('');
        setSelectedBank(null);
        // Limpiar campos de cuenta bancaria
        setNombres('');
        setApellidos('');
        setTipoDocumento(0);
        setDocumento('');
        setBancoSeleccionado(null);
        setNumeroCuenta('');
        setTipoCuenta(null);
        setErrorADDBank('');
        setPreviousStep(null);
    };

    const backToSelect = () => {
        setRetiroStep("select");
    };

    // Formatear lista de bancos igual que en FastSend
    const formattedBankList = bankUserList.map(bank => {
        // Obtener primer nombre y primer apellido
        let firstName = "";
        let lastName = "";
        if (bank.account_holder_name) {
            const parts = bank.account_holder_name.trim().split(" ");
            firstName = parts[0] || "";
            lastName = parts[1] || "";
        }
        return {
            ...bank,
            bank_name: bankCodeToName[bank.bank_name] || `Banco ${bank.bank_name}`,
            account_type: bank.account_type === 1 ? 'Ahorros' : 'Corriente',
            last_digits: bank.account_number ? bank.account_number.slice(-4) : '',
            short_holder_name: `${firstName} ${lastName}`.trim(),
        };
    });

    const handleDispersion = async () => {
        setLoadingDispersion(true);
        try {
            const accounts = bankAccounts.map(account => ({
                thirdpartybank_id: account.thirdpartybank_id,
                amount: parseFloat(account.amount).toFixed(2)
            }));
            const data = {
                accounts,
                ip: IP,
                latitude: latitude,
                longitude: longitude,
                currency: 'COP'
            };
            const response = await axios.post('/api/dispersion-order/', {
                headers: await getAuthenticatedHeaders(),
                data
            });
            if (response.data.status === 201) {
                setActiveMultiRetiros(false);
                setModalDispersionSuccess(true);
                setBankAccounts([]);
                setSelectedBank(null);
            } else {
                setModalDispersionError(true);
            }
        } catch (error) {
            setModalDispersionError(true);
            console.error('Error en la dispersión:', error);
        } finally {
            setLoadingDispersion(false);
        }
    };

    const closeAllDispersionModals = () => {
        setModalDispersionSuccess(false);
        setActiveMultiRetiros(false);
        setRetiroStep("select");
        setBankAccounts([]);
        setSelectedBank(null);
        setErrorBankAccount('');
    };

    // Funciones para agregar cuenta bancaria
    const handleAccountCreate = () => {
        // Guardar el paso actual antes de ir a add_bank
        setPreviousStep(retiroStep);
        setTipoCuenta('Ahorros');
        setRetiroStep("add_bank");
    };

    const CreateBankAccount = async () => {
        setLoadingBankAccount(true);

        const data = {
            "account_holder_name": `${nombres} ${apellidos}`,
            "account_type": tipoCuenta === "Ahorros" ? 0 : 1,
            "account_holder_document_type": tipoDocumento,
            "account_holder_document": documento,
            "account_number": numeroCuenta,
            "bank_name": bancoSeleccionado,
            "country_registered": "CO",
        };

        try {
            const response = await axios.post('/api/create_third_party_banks', {
                headers: await getAuthenticatedHeaders(),
                data
            });

            if (response.data.status === 201) {
                BankListUser();
                setRetiroStep(previousStep || "multi");
                setBancoSeleccionado(null);
                setPreviousStep(null);
                setErrorADDBank("");

                // Limpiar campos
                setNombres('');
                setApellidos('');
                setTipoDocumento(0);
                setDocumento('');
                setNumeroCuenta('');
                setTipoCuenta(null);
            } else if (response.data.status === 400) {
                const errorMessage = response.data?.data?.message || 'Error al crear la cuenta';

                if (errorMessage === 'Invalida numero de cuenta.') {
                    setErrorADDBank("Número de cuenta inválida");
                } else {
                    setErrorADDBank(errorMessage);
                }
            }
        } catch (error) {
            setErrorADDBank("Error al crear la cuenta bancaria");
            console.error(error);
        } finally {
            setLoadingBankAccount(false);
        }
    };

    const backToMulti = () => {
        setRetiroStep(previousStep || "multi");
        setPreviousStep(null);
        // Limpiar campos
        setNombres('');
        setApellidos('');
        setTipoDocumento(0);
        setDocumento('');
        setBancoSeleccionado(null);
        setNumeroCuenta('');
        setTipoCuenta(null);
        setErrorADDBank('');
    };

    return (
        <>
            <ModalQuote
                activeQoute={activeQoute}
                setActiveQoute={setActiveQoute}
                loadingAddressQr={loadingAddressQr}
                addressQrUSDT={addressQrUSDT}
                addressQrUSDC={addressQrUSDC}
            />
            <Create2FA
                backOTP={backOTP}
                onCloseFinal={onCloseOTP}
                OTPCreate={OTPCreate}
                Modal2FA={Modal2FA}
                setModal2FA={setModal2FA}
                loadingOTP={loadingOTP}
                QRValue={DataQr}
                otp={otp}
                handleChange={handleChange}
                handleKeyDown={handleKeyDown}
                handlePaste={handlePaste}
                isOTP={isOTP}
                setisOTP={setisOTP}
                errorOTP={errorOTP}
            />
            <ModalSend
                quote={true}
                currencyCoin={"COP"}
                MovementsList={MovementsList}
                pasesito={1}
                WalletBalanceHome={WalletBalanceHomeCOP}
                balanceWalletCop={balanceWalletCOP}
                balanceWalletUsd={balanceWalletUsd}
                activeDepositar={activeSend}
                setActiveDepositar={setActiveSend}
            />

            {/* Modal de selección de tipo de retiro */}
            {activeMultiRetiros && retiroStep === "select" && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50 p-3">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-full max-w-2xl h-auto flex flex-col justify-between"
                        variants={{
                            hidden: { scale: 0, opacity: 0 },
                            visible: {
                                scale: 1,
                                opacity: 1,
                                transition: { duration: 0.5, ease: "easeOut" }
                            },
                            exit: {
                                scale: 0.8,
                                opacity: 0,
                                transition: { duration: 0.5, ease: "easeInOut" }
                            },
                        }}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div className="p-4 sm:p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-base sm:text-lg font-semibold text-white">
                                    Seleccionar tipo de retiro
                                </p>
                                <IoIosClose
                                    size={24}
                                    color={"#b7b7b9"}
                                    onClick={closeMultiRetiros}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        <div className="flex-grow px-4 sm:px-6 h-full overflow-y-auto max-h-[70vh] md:max-h-[80vh]">
                            <motion.div
                                className="bg-[#26262D]"
                                variants={{
                                    hidden: { scale: 0, opacity: 0 },
                                    visible: {
                                        scale: 1,
                                        opacity: 1,
                                        transition: { duration: 0.5, ease: "easeOut" }
                                    },
                                    exit: {
                                        scale: 0.8,
                                        opacity: 0,
                                        transition: { duration: 0.5, ease: "easeInOut" }
                                    },
                                }}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <SelectSend
                                    balanceBanck="Selecciona una cuenta bancaria para retirar tu saldo"
                                    balanceUSDT="Envía a varias cuentas bancarias al mismo tiempo"
                                    labelBanck="Retiro Rápido"
                                    labelUsd="Dispersión Múltiple"
                                    FastSendButton={handleFastSendRetiro}
                                    GroupSendButton={handleMultiSendRetiro}
                                />
                            </motion.div>
                        </div>
                    </motion.div>
                </div>
            )}

            {/* Modal de multi retiros */}
            {activeMultiRetiros && retiroStep === "multi" && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50 p-3">
                    <motion.div
                        className="bg-[#26262D] rounded-lg min-h-[500px] md:min-h-[700px] shadow-lg w-full max-w-5xl h-auto flex flex-col justify-between overflow-hidden"
                        variants={{
                            hidden: { scale: 0, opacity: 0 },
                            visible: {
                                scale: 1,
                                opacity: 1,
                                transition: { duration: 0.5, ease: "easeOut" }
                            },
                            exit: {
                                scale: 0.8,
                                opacity: 0,
                                transition: { duration: 0.5, ease: "easeInOut" }
                            },
                        }}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div className="p-4 sm:p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-base sm:text-lg font-semibold text-white">
                                    Dispersión Múltiple - Retiros
                                </p>
                                <IoIosClose
                                    size={24}
                                    color={"#b7b7b9"}
                                    onClick={closeMultiRetiros}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        <div className="flex-grow px-4 sm:px-6 h-full overflow-y-auto max-h-[70vh] md:max-h-[80vh]">
                            <div className="h-full flex w-full">
                                <motion.div
                                    className="w-[100%] min-h-[600px] h-auto flex flex-col justify-between"
                                    variants={{
                                        hidden: { scale: 0, opacity: 0 },
                                        visible: {
                                            scale: 1,
                                            opacity: 1,
                                            transition: { duration: 0.5, ease: "easeOut" }
                                        },
                                        exit: {
                                            scale: 0.8,
                                            opacity: 0,
                                            transition: { duration: 0.5, ease: "easeInOut" }
                                        },
                                    }}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <MultiSendBank
                                        balanceWalletCop={balanceWalletCOP}
                                        loading={loadingBankAccount}
                                        balanceWalletUsd={balanceWalletUsd}
                                        currency={"COP"}
                                        validateBankAccount={validateBankAccount}
                                        bankAccounts={bankAccounts}
                                        setBankAccounts={setBankAccounts}
                                        error={errorBankAccount}
                                        bankList={formattedBankList}
                                        selectedBank={selectedBank}
                                        setSelectedBank={setSelectedBank}
                                        handleAccountCreate={handleAccountCreate}
                                    />
                                </motion.div>
                            </div>
                        </div>

                        {/* Botones en la parte inferior */}
                        <div className="px-4 sm:px-6 py-4 sm:mb-6 flex justify-between">
                            <ButtonBack
                                onClick={backToMulti}
                                label={'Volver'}
                                className="text-sm sm:text-base"
                                isDisabled={loadingDispersion}
                            />
                            <ButtonWhite
                                isDisabled={
                                    loadingDispersion ||
                                    bankAccounts.length === 0 ||
                                    bankAccounts.some(account =>
                                        account.amount === undefined || account.amount === null || account.amount === "" ||
                                        (account.amount < 10000)
                                    )
                                }
                                loading={loadingDispersion}
                                onClick={handleDispersion}
                                label="Continuar con la dispersión"
                                className="text-sm sm:text-base"
                            />
                        </div>
                    </motion.div>
                </div>
            )}

            {/* Modal de éxito de dispersión */}
            {modalDispersionSuccess && (
                <ModalAlert
                    title='Dispersión exitosa'
                    description='Pronto verás reflejado el monto en las cuentas seleccionadas.'
                    labelButtonWhite='Entendido'
                    onClick={closeAllDispersionModals}
                />
            )}
            {/* Modal de error de dispersión */}
            {modalDispersionError && (
                <ModalAlert
                    title='Error en la dispersión'
                    description='Ocurrió un error al procesar la dispersión. Por favor, verifica los datos e inténtalo de nuevo.'
                    labelButtonWhite='Entendido'
                    onClick={() => setModalDispersionError(false)}
                />
            )}

            {/* Modal de agregar cuenta bancaria */}
            {activeMultiRetiros && retiroStep === "add_bank" && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50 p-3">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-full max-w-2xl h-auto flex flex-col justify-between"
                        variants={{
                            hidden: { scale: 0, opacity: 0 },
                            visible: {
                                scale: 1,
                                opacity: 1,
                                transition: { duration: 0.5, ease: "easeOut" }
                            },
                            exit: {
                                scale: 0.8,
                                opacity: 0,
                                transition: { duration: 0.5, ease: "easeInOut" }
                            },
                        }}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div className="p-4 sm:p-6">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-base sm:text-lg font-semibold text-white">
                                    Agregar cuenta bancaria
                                </p>
                                <IoIosClose
                                    size={24}
                                    color={"#b7b7b9"}
                                    onClick={closeMultiRetiros}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        <div className="flex-grow px-4 sm:px-6 h-full overflow-y-auto max-h-[70vh] md:max-h-[80vh]">
                            <motion.div
                                className="bg-[#26262D]"
                                variants={{
                                    hidden: { scale: 0, opacity: 0 },
                                    visible: {
                                        scale: 1,
                                        opacity: 1,
                                        transition: { duration: 0.5, ease: "easeOut" }
                                    },
                                    exit: {
                                        scale: 0.8,
                                        opacity: 0,
                                        transition: { duration: 0.5, ease: "easeInOut" }
                                    },
                                }}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                                <CreateAccountBank
                                    selectMethod={null}
                                    setWire={() => { }}
                                    wire=""
                                    listaBancosEEUU={[]}
                                    rountingNum=""
                                    setRountingNum={() => { }}
                                    setAccountCountry={() => { }}
                                    AccountCountry=""
                                    currency="COP"
                                    errorADDBank={errorADDBank}
                                    nombres={nombres}
                                    setNombres={setNombres}
                                    apellidos={apellidos}
                                    setApellidos={setApellidos}
                                    tipoDocumento={tipoDocumento}
                                    setTipoDocumento={setTipoDocumento}
                                    documento={documento}
                                    setDocumento={setDocumento}
                                    bancoSeleccionado={bancoSeleccionado}
                                    setBancoSeleccionado={setBancoSeleccionado}
                                    listaBancos={listaBancos}
                                    errorBanco={false}
                                    numeroCuenta={numeroCuenta}
                                    setNumeroCuenta={setNumeroCuenta}
                                    numeroRuta=""
                                    setNumeroRuta={() => { }}
                                    tipoCuenta={tipoCuenta}
                                    setTipoCuenta={setTipoCuenta}
                                    nombreCuenta=""
                                    setNombreCuenta={() => { }}
                                />
                            </motion.div>
                        </div>

                        {/* Botones en la parte inferior */}
                        <div className="px-4 sm:px-6 py-4 sm:mb-6 flex justify-between">
                            <ButtonBack
                                onClick={backToMulti}
                                label={'Volver'}
                                className="text-sm sm:text-base"
                                isDisabled={loadingBankAccount}
                            />
                            <ButtonWhite
                                isDisabled={
                                    loadingBankAccount ||
                                    nombres.trim() === '' ||
                                    apellidos.trim() === '' ||
                                    documento.trim() === '' ||
                                    bancoSeleccionado === null ||
                                    numeroCuenta.trim() === '' ||
                                    tipoCuenta === null
                                }
                                loading={loadingBankAccount}
                                onClick={CreateBankAccount}
                                label="Guardar"
                                className="text-sm sm:text-base"
                            />
                        </div>
                    </motion.div>
                </div>
            )}

            <ConfirmPurchase
                Percent={Percent}
                activeConfimPurchase={activeConfimPurchase}
                setActiveConfimPurchase={setActiveConfimPurchase}
                contador={counter}
                tasaForex={tasaForex}
                amountUSD={amountUSD}
                finalAmountCOP={amountCOP}
                purchaseCommission={purchaseCommission}
                purchaseCommissionIVA={purchaseCommissionIVA}
                totalPurchase={totalPurchase}
                setConfirmPurchase={setConfirmPurchase}
                Check={Check}
                confirmPurchase={confirmPurchase}
                activeCompraFinal={activeCompraFinal}
                setActiveCompraFinal={setActiveCompraFinal}
                setContador={setContador}
                setAmountUSD={setAmountUSD}
                setActiveEjecutar={setActiveEjecutar}
                setAmountCOP={setAmountCOP}
                setModalOTP={setModalOTP}
            />
            <ConfirmOTP
                setActiveConfimPurchase={setActiveConfimPurchase}
                setErrorOTP={setErrorOTP}
                loadingOTP={loadingOTP}
                setOtp={setOtpValid}
                otp={otpValid}
                setModal={setModalOTP}
                modal={modalOTP}
                errorOTP={errorOTP}
                setConfirmPurchase={setConfirmPurchase}
            />

            <div className="home">
                {errorTime && <ModalAlert title='Cotización no disponible' description={errorTime} labelButtonWhite='Entendido' onClick={closeAllModals} />}

                <div className='w-full flex flex-col h-[100vh] py-10 px-6 gap-2'>
                    <div className='w-full flex justify-between text-center mb-1'>
                        <div className='flex flex-col justify-end'>
                            <h2 className='text-white text-2xl font-bold leading-8 tracking-tighter mb-2'>Cotizar</h2>
                        </div>
                        <div className='flex flex-row justify-end items-end w-full'>
                            <div className="flex items-center gap-4">
                                {/* Banner de mensaje */}
                                {!loadingAmount && balanceWalletUsd > 0 && DetailUser?.has_otp == false && (
                                    <div className="bg-[#F1D5B3] px-4 py-2 rounded-lg flex items-center shadow-md h-[44px]">
                                        <p className="text-sm font-medium text-[#1a1b22]">
                                            Es necesario tener activado el 2FA para poder realizar cotizaciones. Actívalo aquí.
                                        </p>
                                        <div className="w-4 h-4 bg-[#F1D5B3] left-[30px] rotate-45 ml-2 mr-[-1.25rem]"></div>
                                    </div>
                                )}

                                {DetailUser?.has_otp == false && balanceWalletUsd > 0 && !loadingAmount && (
                                    <ButtonWhite label="Activar 2FA" loading={loadingOTP} isDisabled={false} onClick={() => GetOTP()} />
                                )}

                                {!loadingAmount && balanceWalletUsd <= 0 && (
                                    <div className="bg-[#F1D5B3] px-4 py-2 rounded-lg flex items-center shadow-md h-[36px]">
                                        <p className="text-sm font-medium text-[#1a1b22]">
                                            Recarga tu billetera USD usando USDT o USDC antes de cotizar
                                        </p>
                                        <div className="w-4 h-4 bg-[#F1D5B3] left-[30px] rotate-45 ml-2 mr-[-1.25rem]"></div>
                                    </div>
                                )}

                                {/* Saldo actual */}
                                <div className="flex items-center gap-2 bg-[#1a1b22] pl-4 pr-1.5 py-1.5 w-auto justify-center rounded-xl shadow-md min-h-[44px]">
                                    <img src={USD} alt="USD" className="w-5 h-5 rounded-full" />
                                    <span className="text-[#8A8A8E] text-center text-sm font-bold">USD</span>
                                    {loadingAmount && (
                                        <div className="spinner-border animate-spin w-1 h-1 border-1 border-gray-300 border-t-transparent rounded-full"></div>
                                    )}
                                    {!loadingAmount && (
                                        <span className="text-white text-sm font-semibold">{formatAmount(balanceWalletUsd)}</span>
                                    )}
                                    <button
                                        className="text-white text-[28px] h-[36px] w-[36px] flex justify-center items-center rounded-lg bg-[#26262c] font-bold"
                                        onClick={() => setActiveQoute(true)}
                                    >
                                        <IoIosArrowRoundDown className="rotate-[0deg] size-7" fill="#ffffff" />
                                    </button>
                                </div>
                                <div className="flex items-center gap-2 bg-[#1a1b22] pl-4 pr-1.5 py-1.5 w-auto justify-center rounded-xl shadow-md min-h-[44px]">
                                    <img src={COP} alt="USD" className="w-5 h-5 rounded-full" />
                                    <span className="text-[#8A8A8E] text-center text-sm font-bold">COP</span>
                                    {loadingAmount && (
                                        <div className="spinner-border animate-spin w-1 h-1 border-1 border-gray-300 border-t-transparent rounded-full"></div>
                                    )}
                                    {!loadingAmount && (
                                        <span className="text-white text-sm font-semibold">{formatAmount(balanceWalletCOP)}</span>
                                    )}
                                    <button
                                        className="text-white text-[28px] h-[36px] w-[36px] flex justify-center items-center rounded-lg bg-[#26262c] font-bold"
                                        onClick={() => setActiveMultiRetiros(true)}
                                    >
                                        <IoIosArrowRoundDown className="rotate-[220deg] size-7" fill="#ffffff" />
                                    </button>
                                </div>

                                {/* Límite diario */}
                                <div className="flex items-center bg-[#1a1b22] px-4 py-2 rounded-xl shadow-md h-[44px]">
                                    <span className="text-[#8A8A8E] text-sm">Límite diario</span>
                                    <span className="text-white ml-2 text-sm font-medium">
                                        <span className="text-white font-bold">{formatAmount(MaxAmountCount, '.')}</span> / <span className="text-[#8A8A8E]">{formatAmount(MaxAmount, '.')}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='flex flex-col w-full h-auto justify-around rounded-[12px] gap-4 bg-[#1a1b22] p-6'>
                        <div className='w-full flex flex-row gap-3'>
                            <div className='w-[90%]'>
                                <div className='w-full h-full flex flex-row gap-6 items-center justify-center'>
                                    <InputAmount className='h-full' inputFontSizeClass="text-4xl" readOnly={!DetailUser?.has_otp} error={error} errorMessage={error} currency={"USD"} title='Cuánto envias' value={amountUSD} onChange={(e) => setAmountUSD(e)} />
                                    <IoIosArrowRoundDown className='rotate-[-90deg] size-20' fill='#ffffff' />
                                    <InputAmount className='h-full' inputFontSizeClass="text-4xl" currency={"COP"} title='Cuánto recibes' loading={LoadingData} value={amountCOP} onChange={(e) => setAmountCOP(e)} readOnly={true} />
                                </div>
                            </div>
                            <div className='w-[10%] h-full flex flex-col gap-3 items-center justify-center'>
                                <ButtonBack className={`mt-0 ${activeEjecutar ? "" : "w-full"}`} label={'Cotizar'} loading={loadingCotizar} paddingY={2} isDisabled={activeCotizar || loadingCotizar} onClick={() => PriceDolar()} />
                                <ButtonWhite label={`${activeEjecutar ? `Ejecutar` : `Ejecutar ${counter}s`}`} loading={loading} isDisabled={activeEjecutar || loading} onClick={() => PreExchange()} />
                            </div>
                        </div>
                        <div className='w-full h-auto flex justify-start items-center flex-row gap-4 mt-3'>
                            <p className='text-base text-[#8A8A8E] font-normal traking-[-0.24px] leading-[15.6px]'>TASA:
                                $1 USD = {!LoadingData && <strong className='text-[#ffffff] text-base'>{tasaForex !== 0 ? FormatMontoPSE(tasaForex, true) : "----"}</strong>}</p>
                            {LoadingData && <div className="spinner-border animate-spin w-1 h-1 border-1 border-gray-300 border-t-transparent rounded-full"></div>}
                        </div>
                    </div>
                    <div className='w-full h-auto flex items-center'>
                        <p className='text-base text-[#8A8A8E]'>
                            Mis Cotizaciones
                        </p>
                    </div>

                    <CustomTable loadingTable={LoadingTableSkeleton} newPerPage={newPerPage} pending={loadingTable} totalRows={TotalRow} columns={columns} data={ListData} filterActive={true} downloadActive={true} datos={true} seeMoreActive={false} handlePageChange={handlePageChange} />
                    <div className='w-full h-auto flex items-center'>
                        <p className='text-base text-[#8A8A8E]'>
                            Mis Retiros
                        </p>
                    </div>
                    <CustomTable loadingTable={LoadingTableSkeleton} newPerPage={newPerPage} pending={LoadingTableRetiros} totalRows={TotalRowRetiros} columns={columnsRetiros} data={ListDataRetiros} filterActive={true} downloadActive={true} datos={true} seeMoreActive={false} handlePageChange={handlePageChangeRetiros} />

                </div>
            </div >
        </>
    );
};

export default Quote;